import { Filters } from './filters';
import { FilterTypes } from './filter_types';

const FilterToTypes = {
    // Filters displayed with checkboxes
    [Filters.FREE_FITTING]: FilterTypes.BOOLEAN_FILTER,
    [Filters.BUY_4_PAY_3]: FilterTypes.BOOLEAN_FILTER,
    [Filters.CLEARANCE]: FilterTypes.BOOLEAN_FILTER,
    [Filters.INSTANT_CASH]: FilterTypes.BOOLEAN_FILTER,
    [Filters.RUN_FLAT]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_INSTANT_CASH_50]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_INSTANT_CASH_80]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_INSTANT_CASH_100]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_INSTANT_CASH_120]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_INSTANT_CASH_150]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_INSTANT_CASH_160]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_INSTANT_CASH_200]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_INSTANT_CASH_250]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_INSTANT_CASH_300]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_5_OFF]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_10_OFF]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_15_OFF]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_20_OFF]: FilterTypes.BOOLEAN_FILTER,
    [Filters.DISCOUNT_25_OFF]: FilterTypes.BOOLEAN_FILTER,
    [Filters.PROMO_GIFT_CARD_50]: FilterTypes.BOOLEAN_FILTER,
    [Filters.PROMO_GIFT_CARD_80]: FilterTypes.BOOLEAN_FILTER,
    [Filters.PROMO_GIFT_CARD_100]: FilterTypes.BOOLEAN_FILTER,
    [Filters.PROMO_GIFT_CARD_130]: FilterTypes.BOOLEAN_FILTER,
    [Filters.PROMO_GIFT_CARD_150]: FilterTypes.BOOLEAN_FILTER,
    [Filters.PROMO_GIFT_CARD_200]: FilterTypes.BOOLEAN_FILTER,
    [Filters.PROMO_GIFT_CARD_250]: FilterTypes.BOOLEAN_FILTER,

    [Filters.QUALITY_SEGMENT_PREMIUM]: FilterTypes.BOOLEAN_FILTER,
    [Filters.QUALITY_SEGMENT_VALUE]: FilterTypes.BOOLEAN_FILTER,
    [Filters.QUALITY_SEGMENT_BUDGET]: FilterTypes.BOOLEAN_FILTER,

    // Filters displayed in select dropdowns
    [Filters.USAGE]: FilterTypes.OPTION_FILTER,
    [Filters.WIDTH]: FilterTypes.OPTION_FILTER,
    [Filters.HEIGHT]: FilterTypes.OPTION_FILTER,
    [Filters.DIAMETER]: FilterTypes.OPTION_FILTER,
    [Filters.MANUFACTURER]: FilterTypes.OPTION_FILTER,
    [Filters.MODEL]: FilterTypes.OPTION_FILTER,
    [Filters.VEHICLE_TYPE]: FilterTypes.OPTION_FILTER,
    [Filters.WHEEL_MODEL]: FilterTypes.OPTION_FILTER,
    [Filters.WHEEL_DIAMETER]: FilterTypes.OPTION_FILTER,
    [Filters.WHEEL_WIDTH]: FilterTypes.OPTION_FILTER,
    [Filters.WHEEL_STUDS]: FilterTypes.OPTION_FILTER,
    [Filters.WHEEL_PCD]: FilterTypes.OPTION_FILTER,
    [Filters.WHEEL_FINISH]: FilterTypes.OPTION_FILTER,
    [Filters.VEHICLE_MAKE]: FilterTypes.OPTION_FILTER,
    [Filters.VEHICLE_MODEL]: FilterTypes.OPTION_FILTER,
    [Filters.VEHICLE_YEAR]: FilterTypes.OPTION_FILTER,
    [Filters.VEHICLE_SERIES_CHASSIS]: FilterTypes.OPTION_FILTER,
    [Filters.VEHICLE_ENGINE]: FilterTypes.OPTION_FILTER,
    [Filters.VEHICLE_TYRES]: FilterTypes.OPTION_FILTER,
    [Filters.VEHICLE_DETAILS]: FilterTypes.OPTION_FILTER,
    [Filters.VEHICLE_STATE]: FilterTypes.OPTION_FILTER,
    [Filters.TECHNOLOGY]: FilterTypes.OPTION_FILTER,
    [Filters.LABEL_NOISE]: FilterTypes.OPTION_FILTER,
    [Filters.LABEL_WET_GRIP]: FilterTypes.OPTION_FILTER,
    [Filters.LABEL_FUEL_EFFICIENCY]: FilterTypes.OPTION_FILTER,
    [Filters.UTQG_TREADWEAR_GROUP]: FilterTypes.OPTION_FILTER,
    [Filters.UTQG_TRACTION]: FilterTypes.OPTION_FILTER,
    [Filters.UTQG_TEMPERATURE]: FilterTypes.OPTION_FILTER,
    [Filters.SEASON]: FilterTypes.OPTION_FILTER,
    [Filters.EV]: FilterTypes.OPTION_FILTER,

    [Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP]: FilterTypes.OPTION_FILTER,
    [Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP]: FilterTypes.OPTION_FILTER,
    [Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP]: FilterTypes.OPTION_FILTER,
    [Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP]: FilterTypes.OPTION_FILTER,
    [Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP]: FilterTypes.OPTION_FILTER,
    [Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP]: FilterTypes.OPTION_FILTER,
    [Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP]: FilterTypes.OPTION_FILTER,

    // number filters
    [Filters.SPEED_INDEX]: FilterTypes.NUMBER_FILTER,
    [Filters.LOAD_INDEX]: FilterTypes.NUMBER_FILTER,

    // price ranges
    [Filters.PRICE_MIN]: FilterTypes.PRICE_FILTER,
    [Filters.PRICE_MAX]: FilterTypes.PRICE_FILTER,

    // text input fields
    [Filters.POSTCODE]: FilterTypes.INPUT_FILTER,
    [Filters.REGISTRATION]: FilterTypes.INPUT_FILTER,
};

export { FilterToTypes };